module.exports = __webpack_public_path__ + "img/support_bottom_separate.f5cd5ae3.svg";